import { Component } from '@angular/core';
import { HashComponent } from '../hash/hash.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-hash-element',
  templateUrl: './hash-element.component.html',
  styleUrls: ['../hash/hash.component.css', './hash-element.component.css']
})
export class HashElementComponent extends HashComponent {


  oldHash = undefined;

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.data = [...this.data];
  }

  ngOnInit() {
    super.ngOnInit();
  }

  /** adds the element to the bucket of given index */
  hash(index: number, element: any) {
    if (this.linearProbing && this.hashed[index].length > 0) {
      this.messageService.addAlertWithTimeout(this.get("onlyOneCard"), "danger", 10000);
      return;
    }
    if (!this.linearProbing && index != element.dragData.element.hash) {
      this.messageService.addAlertWithTimeout(this.get("wrongBucket"), "danger", 10000);
      return;
    }
    this.hashed[index].push(element.dragData.element);
    this.hashed[element.dragData.start].splice(this.hashed[element.dragData.start].indexOf(element.dragData.element), 1);
    if (element.dragData.start < this.hashed - length - 1) {
      this.data[element.dragData.start].value--;
    }
    this.data[index].value++;
    this.data = [...this.data];
  }

  /** given element is selected */
  clickValue(element) {
    this.selected = element;
    if (this.selected.precomputed) {
      this.precomputationS = this.selected.precomputed.toString();
    } else {
      this.precomputationS = "";
    }
  }

  checkSolution() {
    if (this.hashed[this.hashed.length - 1].length > 0) {
      this.messageService.addAlertWithTimeout(this.get("notAllHashed"), "danger", 10000);
      return;
    }
    let error = false;
    let oldSelected = this.selected;
    let oldprecomputation = this.precomputationS;
    let temp = {};
    let index = 0;
    for (let bucket of this.hashed) {
      for (let elem of bucket) {
        temp = {
          value: elem.value,
          precomputed: undefined,
          operation: undefined,
          scaled: undefined,
          hash: undefined
        };
        this.selected = temp;
        if (this.elementType == 'number') {
          this.precomputationS = this.selected.value.toString().split("").join(",");
        } else {
          this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
        }
        this.changePrecomputation(true);
        if (this.selected.hash != elem.hash) {
          this.messageService.addAlertWithTimeout(this.selected.value.toString().concat(": ", this.get("WrongHashValue")), "danger", 10000);
          error = true;
        }
        if(!this.hashElements){
        if (this.linearProbing) {
          let i = this.selected.hash;
          let myIndex = index;
          if (i > index) {
            myIndex += this.hashed.length;
          }
          while (i < myIndex) {
            if (this.hashed[i % this.divisor].length == 0) {
              this.messageService.addAlertWithTimeout(this.selected.value.toString().concat(": ", this.get("WrongBucket")), "danger", 10000);
              error = true;
              break;
            }
            i++;
          }
        }
      }
      }
      index++;
    }
    if (!error) {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
    this.selected = oldSelected;
    this.precomputationS = oldprecomputation;

  }

  evaluate(): number[] {
    let oldSelected = this.selected;
    let oldPrecomputationS = this.precomputationS;
    let result = 0;
    let maxPoints = 0;
    let bucketIndex = 0;
    for (let bucket of this.hashed) {
      for (let elem of bucket) {
        let temp = {
          value: elem.value,
          precomputed: undefined,
          operation: undefined,
          scaled: undefined,
          hash: undefined
        };
        this.selected = temp;
        if (this.elementType == 'number') {
          this.precomputationS = this.selected.value.toString().split("").join(",");
        } else {
          this.precomputationS = this.selected.value.toString().split("").map(v => v.toLowerCase().charCodeAt(0) - 96).join(",");
        }
        this.changePrecomputation(true);
        if (this.elementType != 'number' && !this.compute.includes('precomputation') && this.selected.precomputed == elem.precomputed) {
          result += 0.1;
        }
        if (this.elementType != 'number' && !this.compute.includes('precomputation')) {
          maxPoints += 0.1;
        }
        if (this.typeFunction != 'digits' && this.typeFunction != "checksum") {
          if (!this.compute.includes('operation') && this.selected.operation == elem.operation) {
            result += 0.1;
          }
          if (!this.compute.includes('scale') && this.selected.scaled == elem.scaled) {
            result += 0.1;
          }
          if (!this.compute.includes('modulo') && this.selected.hash == elem.hash) {
            result += 0.1;
          }
          if (!this.compute.includes('scale')){
            maxPoints += 0.1;
          }
          if (!this.compute.includes('modulo')){
            maxPoints += 0.1;
          }
        } else {
          if (!this.compute.includes('operation') && this.selected.hash == elem.hash) {
            result += 0.1;
          }
        }
        if (!this.compute.includes('operation')){
          maxPoints += 0.1;
        }
        if (!this.compute.includes('scale')){
          maxPoints += 0.1;
        }
        if (!this.compute.includes('modulo')){
          maxPoints += 0.1;
        }
        if (!this.hashElements) {
          if (!this.linearProbing) {
            if (!this.hashElements && bucketIndex == elem.hash) {
              result += 0.1;
            }
          } else {
            let hash = this.selected.hash;
            let notEmpty = true;
            while (hash % this.divisor != bucketIndex) {
              if (this.hashed[hash % this.divisor].length == 0) {
                notEmpty = false;
              }
            }
            if (notEmpty) {
              result += 0.1;
            }
          }
          maxPoints += 0.1;
        }
      }
      bucketIndex++;
    }
    this.selected = oldSelected;
    this.precomputationS = oldPrecomputationS;
    return [result, maxPoints];
  }

}
